<!--<template>-->
<!--<div>-->
<!--<v-layout v-if="editMode && this.role !== 'user'">-->
<!--<v-flex row>-->
<!--<v-spacer/>-->
<!--<v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">-->
<!--<v-tooltip bottom>-->
<!--<v-icon small slot="activator">file_copy</v-icon>-->
<!--<span>Duplicate Chart</span>-->
<!--</v-tooltip>-->
<!--</v-btn>-->
<!--<v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">-->
<!--<v-tooltip bottom>-->
<!--<v-icon small slot="activator">build</v-icon>-->
<!--<span>Edit Chart</span>-->
<!--</v-tooltip>-->
<!--</v-btn>-->
<!--<v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">-->
<!--<v-tooltip bottom>-->
<!--<v-icon small slot="activator">remove_circle_outline</v-icon>-->
<!--<span>Delete Chart</span>-->
<!--</v-tooltip>-->
<!--</v-btn>-->
<!--</v-flex>-->
<!--</v-layout>-->
<!--<v-flex lg12 md12>-->
<!--<v-card>-->
<!--<loading :active.sync="tableLoading"-->
<!--:can-cancel="false"-->
<!--/>-->
<!--<v-card-title>-->
<!--{{chartName}}-->
<!--<v-spacer></v-spacer>-->
<!--<v-layout row wrap>-->
<!--<v-flex mt-3 lg2 md2>-->
<!--<v-btn flat icon dark slot="activator">-->
<!--<json-excel-->
<!--:data="exportcsv"-->
<!--:before-generate = "startDownload"-->
<!--:before-finish = "finishDownload"-->
<!--type="csv"-->
<!--name="Data.csv"-->
<!--&gt;-->
<!--<v-tooltip bottom>-->
<!--<v-icon slot="activator">cloud_download</v-icon>-->
<!--<span>Download CSV</span>-->
<!--</v-tooltip>-->
<!--</json-excel>-->
<!--</v-btn>-->
<!--</v-flex>-->
<!--<v-flex lg9 md9>-->
<!--<v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details dark />-->
<!--</v-flex>-->
<!--</v-layout>-->
<!--</v-card-title>-->
<!--<v-data-table-->
<!--:headers="headers"-->
<!--:items="desserts"-->
<!--:pagination.sync="pagination"-->
<!--:search="search"-->
<!--class="dark"-->
<!--&gt;-->
<!--<template v-slot:items="props">-->
<!--<td class="text-xs-center" v-for="item in props.item"-->
<!--:key="item">-->
<!--{{item}}-->
<!--</td>-->
<!--</template>-->
<!--<v-alert slot="no-results" :value="true" color="error" icon="warning">-->
<!--Your search for "{{ search }}" found no results.-->
<!--</v-alert>-->
<!--</v-data-table>-->
<!--</v-card>-->
<!--</v-flex>-->
<!--</div>-->
<!--</template>-->

<!--<script>-->
<!--import axios from 'axios'-->
<!--import ResizeSensor from 'css-element-queries/src/ResizeSensor'-->
<!--import JsonExcel from 'vue-json-excel'-->
<!--import Loading from 'vue-loading-overlay'-->
<!--import 'vue-loading-overlay/dist/vue-loading.css'-->
<!--import jwtDecode from 'jwt-decode'-->

<!--export default {-->
<!--name: 'x-tableCustom',-->
<!--components: {-->
<!--JsonExcel,-->
<!--Loading-->
<!--},-->
<!--props: {-->
<!--user_index: String,-->
<!--user_inst: String,-->
<!--width: {-->
<!--type: [String, Number],-->
<!--default: '100%'-->
<!--},-->
<!--height: {-->
<!--type: [String, Number],-->
<!--default: '100%'-->
<!--},-->
<!--startTime: [String, Number],-->
<!--endTime: [String, Number],-->
<!--chartName: {-->
<!--type: String,-->
<!--default: 'Untitled'-->
<!--},-->
<!--chartId: String,-->
<!--options: Array,-->
<!--fields: Array,-->
<!--optionsCustom: Array,-->
<!--fieldCustom: Array,-->
<!--text: {-->
<!--type: String,-->
<!--default: 'type="event" | fields subtype level user action logdesc'-->
<!--},-->
<!--stores: Array,-->
<!--subFilter: {-->
<!--type: String-->
<!--},-->
<!--editMode: {-->
<!--type: Boolean,-->
<!--default: false-->
<!--},-->
<!--slice: {-->
<!--type: [Object]-->
<!--},-->
<!--interval: {-->
<!--type: String,-->
<!--default: '1m'-->
<!--}-->
<!--},-->
<!--data: () => {-->
<!--return {-->
<!--resizeSensor: null,-->
<!--clientHeight: null,-->
<!--tableHeaders: [],-->
<!--sub: '',-->
<!--headers: [],-->
<!--desserts: [],-->
<!--pagination: {-->
<!--rowsPerPage: 10-->
<!--},-->
<!--search: '',-->
<!--tableLoading: false,-->
<!--exportcsv: [],-->
<!--role: '',-->
<!--decoded: '',-->
<!--token: ''-->
<!--}-->
<!--},-->
<!--mounted () {-->
<!--const vm = this-->
<!--this.gridItem = this.$parent-->
<!--this.resizeSensor = new ResizeSensor(this.$el, () => {-->
<!--const widgetHeight = this.$el.clientHeight-->
<!--if (widgetHeight !== vm.widgetHeight) {-->
<!--const newH = Math.ceil((widgetHeight + vm.gridItem.margin[1]) / (vm.gridItem.rowHeight + vm.gridItem.margin[1]))-->
<!--vm.widgetHeight = widgetHeight-->
<!--vm.gridItem.eventBus.$emit(-->
<!--'resizeEvent',-->
<!--'resized',-->
<!--vm.gridItem.i,-->
<!--vm.gridItem.x,-->
<!--vm.gridItem.y,-->
<!--newH,-->
<!--vm.gridItem.w-->
<!--)-->
<!--}-->
<!--})-->
<!--this.widgetHeight = this.$el.clientHeight-->
<!--this.tableHeaders = this.fields-->
<!--this.initTable()-->
<!--},-->
<!--created () {-->
<!--this.token = sessionStorage.getItem('user-token')-->
<!--this.decoded = jwtDecode(this.token)-->
<!--this.role = this.decoded.role-->
<!--this.fields = this.fields.concat(this.fieldCustom)-->
<!--let uniqueAddresses = Array.from(new Set(this.fields.map(a => a.key)))-->
<!--.map(key => {-->
<!--return this.fields.find(a => a.key === key)-->
<!--})-->
<!--for (let ele of uniqueAddresses) {-->
<!--let a = ele.key.match(/([@])/g)-->
<!--? this.jsUcfirst((ele.key.match(/[^(@)]/g)).join(''))-->
<!--: ele.key.match(/([_])/g)-->
<!--? this.jsUcfirst((ele.key.match(/[a-z]((?!(_))\w)*[a-z]/g)).join(' '))-->
<!--: ele.key === 'upload' || ele.key === 'download'-->
<!--? `${this.jsUcfirst(ele.key)} (MB)`-->
<!--: this.jsUcfirst(ele.key)-->
<!--let obj = {-->
<!--text: a,-->
<!--align: 'center',-->
<!--sortable: true,-->
<!--value: ele.key-->
<!--}-->
<!--this.headers.push(obj)-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--// handleDownload () {},-->
<!--async initTable () {-->
<!--this.disposeTable()-->
<!--if (this.subFilter !== '*' && this.text !== '') {-->
<!--this.sub = ''-->
<!--this.sub = `${this.subFilter} AND ${this.text}`-->
<!--} else if (this.subFilter !== '*') {-->
<!--this.sub = ''-->
<!--this.sub = `${this.subFilter}`-->
<!--} else {-->
<!--}-->
<!--try {-->
<!--let response = await axios.post(apiUrl + '/api/query/searchCustom', {-->
<!--start: this.startTime,-->
<!--end: this.endTime,-->
<!--instance: this.user_inst,-->
<!--index: this.user_index,-->
<!--stores: this.stores,-->
<!--sub: this.sub,-->
<!--text: this.text,-->
<!--bodySize: 500,-->
<!--field: this.options,-->
<!--fieldCustom: this.optionsCustom,-->
<!--allfield: this.options.concat(this.optionsCustom),-->
<!--interval: this.interval-->
<!--})-->
<!--this.desserts = response.data-->
<!--for (let [num] of this.desserts.entries()) {-->
<!--if (this.desserts[num].download !== undefined) {-->
<!--this.desserts[num].download = ((this.desserts[num].download.value) / 1024 / 1024).toFixed(2)-->
<!--}-->
<!--if (this.desserts[num].upload !== undefined) {-->
<!--this.desserts[num].upload = ((this.desserts[num].upload.value) / 1024 / 1024).toFixed(2)-->
<!--}-->
<!--}-->
<!--} catch (error) {-->
<!--console.error(error)-->
<!--}-->
<!--},-->
<!--disposeTable () {-->
<!--this.desserts = []-->
<!--},-->
<!--duplicateChart () {-->
<!--this.$emit('duplicateChart', this.slice)-->
<!--},-->
<!--jsUcfirst (string) {-->
<!--return string.charAt(0).toUpperCase() + string.slice(1)-->
<!--},-->
<!--startDownload () {-->
<!--this.tableLoading = true-->
<!--this.exportcsv = this.desserts.map(dessert => {-->
<!--return {-->
<!--...dessert,-->
<!--...(dessert.download && {-->
<!--download: `${dessert.download} MB`-->
<!--}),-->
<!--...(dessert.upload && {-->
<!--upload: `${dessert.upload} MB`-->
<!--})-->
<!--}-->
<!--})-->
<!--},-->
<!--finishDownload () {-->
<!--this.tableLoading = false-->
<!--}-->
<!--},-->
<!--watch: {-->
<!--startTime: {-->
<!--handler: function (startTime) {-->
<!--this.disposeTable()-->
<!--this.initTable()-->
<!--}-->
<!--},-->
<!--endTime: {-->
<!--handler: function (endTime) {-->
<!--this.disposeTable()-->
<!--this.initTable()-->
<!--}-->
<!--},-->
<!--stores: {-->
<!--handler: function (stores) {-->
<!--this.disposeTable()-->
<!--this.initTable()-->
<!--}-->
<!--},-->
<!--text: {-->
<!--handler: function (text) {-->
<!--this.disposeTable()-->
<!--this.initTable()-->
<!--}-->
<!--},-->
<!--user_index: {-->
<!--handler: function (user_index) {-->
<!--this.disposeTable()-->
<!--this.initTable()-->
<!--}-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->
<!--</style>-->

<template>
  <div class="chart chart-move">
    <v-layout v-if="editMode" class="chart-tool">
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on" style="outline: none;" @click="action">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile
            @click="$emit('duplicate-chart', slice)"
            v-scroll-to="'#down'"
          >
            <v-icon size="16" style="color: #757575;">file_copy</v-icon>
            <v-list-tile-title style=" margin-left: 5px; color: #757575;"
              >Duplicate</v-list-tile-title
            >
          </v-list-tile>
          <v-list-tile @click="$emit('edit-chart', chartId)">
            <v-icon size="16" style="color: #757575;">build</v-icon>
            <v-list-tile-title style=" margin-left: 5px; color: #757575;"
              >Edit</v-list-tile-title
            >
          </v-list-tile>
          <v-list-tile @click="$emit('deleteChart', chartId)">
            <v-icon size="16" style="color: #757575;"
              >remove_circle_outline</v-icon
            >
            <v-list-tile-title style=" margin-left: 5px; color: #757575;"
              >Delete</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
    <v-flex lg12 md12>
      <v-card>
        <loading :active.sync="tableLoading" :can-cancel="false" />
        <v-card-title>
          {{ chartName }}
          <v-spacer></v-spacer>
          <v-layout row wrap>
            <v-flex mt-3 lg2 md2>
              <v-btn flat icon dark slot="activator">
                <json-excel
                  :data="exportcsv"
                  :before-generate="startDownload"
                  :before-finish="finishDownload"
                  type="csv"
                  name="Data.csv"
                >
                  <v-tooltip bottom>
                    <v-icon slot="activator">cloud_download</v-icon>
                    <span>Download CSV</span>
                  </v-tooltip>
                </json-excel>
              </v-btn>
            </v-flex>
            <v-flex lg9 md9>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                dark
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          :search="search"
          class="dark"
        >
          <template v-slot:items="props">
            <td class="text-xs-center" v-for="item in props.item" :key="item">
              {{ item }}
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import axios from "axios";
import ResizeSensor from "css-element-queries/src/ResizeSensor";
import JsonExcel from "vue-json-excel";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import jwtDecode from "jwt-decode";

export default {
  name: "x-tableCustom",
  components: {
    JsonExcel,
    Loading
  },
  props: {
    user_index: String,
    user_inst: String,
    width: {
      type: [String, Number],
      default: "100%"
    },
    height: {
      type: [String, Number],
      default: "100%"
    },
    startTime: [String, Number],
    endTime: [String, Number],
    chartName: {
      type: String,
      default: "Untitled"
    },
    chartId: String,
    options: Array,
    fields: Array,
    optionsCustom: Array,
    fieldCustom: Array,
    text: {
      type: String,
      default: 'type="event" | fields subtype level user action logdesc'
    },
    stores: Array,
    subFilter: {
      type: String
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    interval: {
      type: String,
      default: "1m"
    }
  },
  data: () => {
    return {
      resizeSensor: null,
      clientHeight: null,
      tableHeaders: [],
      sub: "",
      headers: [],
      desserts: [],
      pagination: {
        rowsPerPage: 10
      },
      search: "",
      tableLoading: false,
      exportcsv: [],
      role: "",
      decoded: "",
      token: ""
    };
  },
  mounted() {
    const vm = this;
    this.gridItem = this.$parent;
    this.resizeSensor = new ResizeSensor(this.$el, () => {
      const widgetHeight = this.$el.clientHeight;
      if (widgetHeight !== vm.widgetHeight) {
        const newH = Math.ceil(
          (widgetHeight + vm.gridItem.margin[1]) /
            (vm.gridItem.rowHeight + vm.gridItem.margin[1])
        );
        vm.widgetHeight = widgetHeight;
        vm.gridItem.eventBus.$emit(
          "resizeEvent",
          "resized",
          vm.gridItem.i,
          vm.gridItem.x,
          vm.gridItem.y,
          newH,
          vm.gridItem.w
        );
      }
    });
    this.widgetHeight = this.$el.clientHeight;
    this.tableHeaders = this.fields;
    this.initTable();
  },
  created() {
    this.token = sessionStorage.getItem("user-token");
    this.decoded = jwtDecode(this.token);
    this.role = this.decoded.role;
    this.fields = this.fields.concat(this.fieldCustom);
    let uniqueAddresses = Array.from(new Set(this.fields.map(a => a.key))).map(
      key => {
        return this.fields.find(a => a.key === key);
      }
    );
    for (let ele of uniqueAddresses) {
      let a = ele.key.match(/([@])/g)
        ? this.jsUcfirst(ele.key.match(/[^(@)]/g).join(""))
        : ele.key.match(/([_])/g)
        ? this.jsUcfirst(ele.key.match(/[a-z]((?!(_))\w)*[a-z]/g).join(" "))
        : ele.key === "upload" || ele.key === "download"
        ? `${this.jsUcfirst(ele.key)} (MB)`
        : this.jsUcfirst(ele.key);
      let obj = {
        text: a,
        align: "center",
        sortable: true,
        value: ele.key
      };
      this.headers.push(obj);
    }
  },
  methods: {
    // handleDownload () {},
    async initTable() {
      this.disposeTable();
      if (this.subFilter !== "*" && this.text !== "") {
        this.sub = "";
        this.sub = `${this.subFilter} AND ${this.text}`;
      } else if (this.subFilter !== "*") {
        this.sub = "";
        this.sub = `${this.subFilter}`;
      } else {
      }
      try {
        let response = await axios.post(apiUrl + "/api/query/searchCustom", {
          start: this.startTime,
          end: this.endTime,
          instance: this.user_inst,
          index: this.user_index,
          stores: this.stores,
          sub: this.sub,
          text: this.text,
          bodySize: 500,
          field: this.options,
          fieldCustom: this.optionsCustom,
          allfield: this.options.concat(this.optionsCustom),
          interval: this.interval
        });
        this.desserts = response.data;
        for (let [num] of this.desserts.entries()) {
          if (this.desserts[num].download !== undefined) {
            this.desserts[num].download = (
              this.desserts[num].download.value /
              1024 /
              1024
            ).toFixed(2);
          }
          if (this.desserts[num].upload !== undefined) {
            this.desserts[num].upload = (
              this.desserts[num].upload.value /
              1024 /
              1024
            ).toFixed(2);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    disposeTable() {
      this.desserts = [];
    },
    duplicateChart() {
      this.$emit("duplicateChart", this.slice);
    },
    jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    startDownload() {
      this.tableLoading = true;
      this.exportcsv = this.desserts.map(dessert => {
        return {
          ...dessert,
          ...(dessert.download && {
            download: `${dessert.download} MB`
          }),
          ...(dessert.upload && {
            upload: `${dessert.upload} MB`
          })
        };
      });
    },
    finishDownload() {
      this.tableLoading = false;
    }
  },
  watch: {
    startTime: {
      handler: function(startTime) {
        this.disposeTable();
        this.initTable();
      }
    },
    endTime: {
      handler: function(endTime) {
        this.disposeTable();
        this.initTable();
      }
    },
    stores: {
      handler: function(stores) {
        this.disposeTable();
        this.initTable();
      }
    },
    text: {
      handler: function(text) {
        this.disposeTable();
        this.initTable();
      }
    },
    user_index: {
      handler: function(user_index) {
        this.disposeTable();
        this.initTable();
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/x-tableCustom.vue